<!-- 由 suu 创建于 2022-01-24 星期三 -->
<template>
  <div class="ques-steps">
    <div class="previous">
      <span v-if="current > 1" @click="preStep">上一题</span>
    </div>
    <div class="total">
      <div class="current" :style="{ width: percentage + '%' }"></div>
    </div>
    <div>{{ current }}/{{ total }}</div>
  </div>
</template>

<script>
export default {
  name: 'ques-steps',

  components: {},

  props: {
    current: {},
    total: {}
  },

  data() {
    return {
      percentage: 0
    }
  },

  computed: {},

  watch: {
    current(nv) {
      this.percentage = this.computePercentage(nv, this.total)
    }
  },

  created() {
    this.percentage = this.computePercentage(this.current, this.total)
  },

  mounted() {},

  destroyed() {},

  methods: {
    preStep() {
      this.$emit('prestep')
    },
    computePercentage(current, total) {
      let percentage = parseFloat(((current / total) * 100).toFixed(2))
      return percentage
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 750) * 100vw;
}
.ques-steps {
  padding: vw(0) vw(14);
  box-sizing: border-box;
  display: flex;
  align-items: center;
  width: 100%;
  font-size: vw(30);
  color: #000;
  .previous {
    min-width: vw(90);
  }
  .total {
    margin: vw(0) vw(32);
    margin-right: vw(24);
    flex: 1;
    overflow: hidden;
    flex-shrink: 0;
    height: vw(16);
    position: relative;
    background-color: rgb(217, 217, 217);
    border-radius: vw(28);
  }
  .current {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    height: 100%;
    transition: width 0.2s linear;
    background-color: #4b77ee;
    border-radius: vw(28);
  }
}
</style>
